import http from "axios";
import {loadFont} from '../../../shared/font-loader';
import {setPricing} from '../pricing';
import palettes from '../../../shared/palettes.json';
import {setAvailability,unavailable} from '../availability';
http.defaults.timeout = 15000;
const visitSessions={};
function visitToken(restaurant){
  const key='brb-visit:'+restaurant,now=Date.now();
  let session=visitSessions[key];
  try{session=JSON.parse(sessionStorage.getItem(key))||session;}catch(error){/* Se usa memoria si el navegador no permite almacenamiento. */}
  if(!session||!/^[a-f0-9]{32}$/.test(session.token)||!Number.isFinite(session.touched)||now-session.touched>=30*60000){
    const bytes=new Uint8Array(16);window.crypto.getRandomValues(bytes);
    session={token:Array.from(bytes,value=>value.toString(16).padStart(2,'0')).join('')};
  }
  session.touched=now;visitSessions[key]=session;
  try{sessionStorage.setItem(key,JSON.stringify(session));}catch(error){/* Sin persistencia entre recargas. */}
  return session.token;
}

export function imageUrl(image) {
  if (!image || !image.startsWith("/recursos/platos/")) return "";
  return process.env.VUE_APP_API_URL.replace(/\/api\/?$/, "") + image;
}

export async function carta() {
  const selected = new URLSearchParams(window.location.search).get("restaurante");
  let data;
  try { data = await (
    await http.get(
      `${process.env.VUE_APP_API_URL}/carta/${encodeURIComponent(selected || window.location.hostname)}`,
      {headers:{'x-visit-id':visitToken(selected || window.location.hostname)}}
    )
  ).data; } catch(error){unavailable(error);throw error;}
  setAvailability(data);
  const palette = palettes.find(p => p.id === data.palette) || palettes[0];
  for (const key of ['brand','accent','paper','soft']) document.documentElement.style.setProperty('--'+key,palette[key]);
  const appearance = data.appearance || {};
  document.documentElement.style.setProperty('--customer-font',loadFont(appearance.font));
  const background = imageUrl(appearance.background);
  const opacity = (appearance.backgroundOpacity === undefined ? 85 : appearance.backgroundOpacity)/100;
  const rgb = palette.paper.slice(1).match(/../g).map(part=>parseInt(part,16)).join(',');
  document.documentElement.style.setProperty('--wallpaper',background ? `linear-gradient(rgba(${rgb},${opacity}),rgba(${rgb},${opacity})),url("${background}")` : 'none');
  setPricing(data);
  return data;
}
export async function getAlergenos() {
  return await (
    await http.get(`${process.env.VUE_APP_API_URL}/recursos/alergenos`)
  ).data.alergenos;
}
export async function getIconos() {
  return await (
    await http.get(`${process.env.VUE_APP_API_URL}/recursos/iconos`)
  ).data.iconos;
}
